import { render, staticRenderFns } from "./AlertsNew.vue?vue&type=template&id=04876f9f&"
import script from "./AlertsNew.vue?vue&type=script&lang=js&"
export * from "./AlertsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports